import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const Nutritiontimingpreandpostworkoutmeals = () => {
    return (
        <div>
            <Helmet>
                <title>Nutrition Timing: Pre- and Post-Workout Meals - Ramp Physio and Fitness</title>
                <meta name="description" content="Maximize your workout results with optimal nutrition timing. Learn the best foods to fuel your body before and after exercise with Ramp Physio and Fitness." />
            </Helmet>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Master Your Nutrition Timing</h1>
                    <h2>Unlock the secrets of pre- and post-workout meals to enhance your performance and recovery with Ramp Physio and Fitness's expert guidance.</h2>
                    <p>Nutrition timing is a critical component of any fitness regimen. Understanding what to eat before and after a workout can significantly impact your energy levels, performance, and recovery rate. At Ramp Physio and Fitness, we provide you with evidence-based guidance on how to fuel your body effectively around your exercise schedule. This article will explore the importance of pre- and post-workout nutrition and provide practical tips for optimizing your meal timing.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                    >
                        Learn More
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Nutrition Timing" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Pre-Workout Nutrition Fundamentals</h1>
                        <p>Proper pre-workout nutrition is all about fuelling your body with the right energy sources to perform at its best. Carbohydrates are the primary fuel for high-intensity workouts, while protein can help reduce muscle damage. Here are key ideas to consider for your pre-workout meal:</p>
                        <ul>
                            <li>Timing: Eat a complete meal 2-3 hours before training, or a smaller meal or snack 30-60 minutes prior.</li>
                            <li>Carbohydrates: Choose complex carbs for sustained energy.</li>
                            <li>Protein: Include a moderate amount of protein to support muscle health.</li>
                            <li>Hydration: Drink plenty of water to ensure you're well-hydrated.</li>
                            <li>Avoid heavy fats and excessive fiber right before workouts to prevent discomfort.</li>
                        </ul>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Post-Workout Recovery Essentials</h1>
                    <p>After exercising, your body needs to replenish its glycogen stores and repair muscle tissues. A post-workout meal should include:</p>
                    <ul>
                        <li>Protein: Consume 20-40 grams to aid in muscle repair and growth.</li>
                        <li>Carbohydrates: Replenish energy stores with a mix of simple and complex carbs.</li>
                        <li>Timing: Aim to eat within 45 minutes after exercising for optimal recovery.</li>
                        <li>Hydration: Continue to rehydrate with water or an electrolyte drink.</li>
                        <li>Fats: Include healthy fats in moderation, as they're essential for overall health.</li>
                    </ul>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                    >
                        Learn More
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Nutrition Timing for Weight Management</h1>
                    <p>Whether you're looking to lose weight or build muscle, the timing of your meals can play a significant role. Here are several points to remember:</p>
                    <ul>
                        <li>For weight loss, focus on a calorie deficit but ensure you're still fueling workouts.</li>
                        <li>When building muscle, a calorie surplus is often necessary, alongside timing protein intake for muscle repair.</li>
                        <li>Snack smartly with nutrient-dense options that support your goals.</li>
                        <li>Consider the timing and type of nutrients to maximize fat oxidation or muscle synthesis.</li>
                        <li>Stay consistent with meal timing to help regulate hunger and improve metabolic responses.</li>
                    </ul>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Top Pre- and Post-Workout Foods</h1>
                    <p>Choosing the right foods is crucial for effective nutrition timing. Here are ten excellent options for pre- and post-workout meals:</p>
                    <ul>
                        <li>Pre-Workout: Oatmeal with banana and almonds.</li>
                        <li>Pre-Workout: Greek yogurt with berries and honey.</li>
                        <li>Pre-Workout: Whole grain toast with avocado and egg.</li>
                        <li>Pre-Workout: Smoothie with spinach, berries, and protein powder.</li>
                        <li>Pre-Workout: Brown rice with chicken and vegetables.</li>
                        <li>Post-Workout: Protein shake with banana and peanut butter.</li>
                        <li>Post-Workout: Grilled salmon with sweet potato and broccoli.</li>
                        <li>Post-Workout: Quinoa salad with chickpeas, feta, and mixed greens.</li>
                        <li>Post-Workout: Cottage cheese with pineapple and chia seeds.</li>
                        <li>Post-Workout: Turkey and cheese on whole-grain bread with a side salad.</li>
                    </ul>
                </div>
            </div>
            </SkewedContainer>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default Nutritiontimingpreandpostworkoutmeals;